export const UPGRADE_REASONS = Object.freeze([
  'free_status',
  'scenario_map_remaining',
  'scenario_map_limit',
  'ai_followup_remaining',
  'ai_followup_limit',
  'participant_limit',
  'organizer_limit',
  'checkout_cancelled',
  'checkout_processing',
]);

export const UPGRADE_RETURN_ACTIONS = Object.freeze([
  'dashboard',
  'scenario_create',
  'ai_followup',
  'participants',
  'organizers',
]);

const PROMPTS = Object.freeze({
  free_status: Object.freeze({
    heading: 'See what Company unlocks',
    body:
      'Company keeps decisions moving with more active maps and unlimited follow-ups on active maps.',
    cta: 'See Company plan',
    plansHeading: 'Keep decisions moving with Company',
    plansBody: 'Create more active Scenario maps and keep refining decisions without starting over.',
    analyticsSource: 'free_status_strip',
    returnAction: 'dashboard',
  }),
  scenario_map_remaining: Object.freeze({
    heading: 'One free Scenario map remains',
    body:
      'Company keeps decisions moving with more active maps and unlimited follow-ups on active maps.',
    cta: 'See Company plan',
    plansHeading: 'Create your next Scenario',
    plansBody: 'Move from one decision to the next while keeping your existing maps and contributions intact.',
    analyticsSource: 'scenario_creation',
    returnAction: 'scenario_create',
  }),
  scenario_map_limit: Object.freeze({
    heading: 'Ready for the next decision?',
    body:
      'You’ve used both included Scenario maps. Move to Company to create another map and keep your team’s decision rhythm going. Your existing work stays exactly as it is.',
    cta: 'See Company plan',
    plansHeading: 'Create your next Scenario',
    plansBody: 'Create another map while keeping every existing Scenario and contribution exactly as it is.',
    analyticsSource: 'scenario_creation',
    returnAction: 'scenario_create',
  }),
  ai_followup_remaining: Object.freeze({
    heading: 'One AI follow-up is included with Free.',
    body: '',
    cta: '',
    plansHeading: 'Keep this Scenario moving',
    plansBody: 'Company unlocks unlimited follow-ups on active maps so the work can keep evolving.',
    analyticsSource: 'scenario_continuation',
    returnAction: 'ai_followup',
  }),
  ai_followup_limit: Object.freeze({
    heading: 'Keep sharpening this Scenario',
    body:
      'You’ve used the AI follow-up included with Free. Company unlocks unlimited follow-ups on active maps, so you can test assumptions and refine the map without starting over.',
    cta: 'See Company plan',
    plansHeading: 'Keep this Scenario moving',
    plansBody: 'Continue refining this exact Scenario while keeping its map, history and perspectives intact.',
    analyticsSource: 'scenario_continuation',
    returnAction: 'ai_followup',
  }),
  participant_limit: Object.freeze({
    heading: 'Bring the full decision team in',
    body:
      'This Scenario has reached the Free participant allowance. Company gives you room to include more of the people whose perspectives matter.',
    cta: 'See Company plan',
    plansHeading: 'Bring more perspectives into the decision',
    plansBody: 'Invite more participants while preserving every contribution already collected.',
    analyticsSource: 'participant_invitation',
    returnAction: 'participants',
  }),
  organizer_limit: Object.freeze({
    heading: 'Share the organizing work',
    body: 'Move to Company to let another leader help organize Scenarios and keep decisions moving.',
    cta: 'See Company plan',
    plansHeading: 'Share the organizing work',
    plansBody: 'Give another leader organizing access without changing existing workspace roles.',
    analyticsSource: 'workspace_team',
    returnAction: 'organizers',
  }),
  checkout_cancelled: Object.freeze({
    heading: 'No changes were made. Your work is safe.',
    body: 'Your current plan and all existing AffinityAI work remain unchanged.',
    cta: '',
    plansHeading: 'Company',
    plansBody: '',
    analyticsSource: 'checkout_return',
    returnAction: 'dashboard',
  }),
  checkout_processing: Object.freeze({
    heading: 'Confirming your Company plan',
    body: 'Payment is complete. AffinityAI is waiting for verified subscription activation.',
    cta: '',
    plansHeading: 'Company',
    plansBody: '',
    analyticsSource: 'checkout_return',
    returnAction: 'dashboard',
  }),
});

export function isUpgradeReason(value) {
  return UPGRADE_REASONS.includes(String(value || ''));
}

export function isUpgradeReturnAction(value) {
  return UPGRADE_RETURN_ACTIONS.includes(String(value || ''));
}

export function getConversionPrompt(reason = 'free_status') {
  return PROMPTS[isUpgradeReason(reason) ? reason : 'free_status'];
}
